import React from 'react'

const Graph = () => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill="#3F5063" d="M14.3,58.3c-0.6,0-1-0.4-1-1V7.7c0-0.6,0.4-1,1-1s1,0.4,1,1v49.7C15.3,57.9,14.8,58.3,14.3,58.3z"/>
      <path fill="#6EC18A" d="M22.8,48.4c-0.8,0-1.5-0.7-1.5-1.5V28.3c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v18.6
	C24.3,47.7,23.6,48.4,22.8,48.4z"/>
      <path fill="#6EC18A" d="M34.2,48.4c-0.8,0-1.5-0.7-1.5-1.5V18.8c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v28.1
	C35.7,47.7,35,48.4,34.2,48.4z"/>
      <path fill="#6EC18A" d="M45.5,48.4c-0.8,0-1.5-0.7-1.5-1.5V13.1c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v33.7
	C47,47.7,46.3,48.4,45.5,48.4z"/>
      <rect x="10" y="52.1" fill="#3F5063" width="45" height="2"/>
    </svg>
  )
}

export default Graph
